var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLayoutShape1 = function SvgLayoutShape1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h8zm7 10.5a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-7.5a1 1 0 0 1 1-1h3zm6 0a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-7.5a1 1 0 0 1 1-1h3zM16 0a1 1 0 0 1 1 1v7.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h3zm6 0a1 1 0 0 1 1 1v7.5a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h3z",
    fillRule: "evenodd"
  })));
};
export default SvgLayoutShape1;